import { tickerItems } from '../../../mocks/news';

export default function Ticker() {
  const doubled = [...tickerItems, ...tickerItems];
  return (
    <div
      className="w-full bg-foreground-950 text-foreground-100 overflow-hidden"
      role="region"
      aria-label="实时快讯滚动条"
    >
      <div className="mx-auto max-w-7xl px-0 md:px-6">
        <div className="flex items-stretch">
          <div className="shrink-0 flex items-center gap-1.5 bg-primary-500 text-background-50 px-3 md:px-4 py-2.5 font-bold text-xs md:text-sm tracking-wide z-10">
            <i className="ri-radio-2-line text-sm md:text-base" aria-hidden="true" />
            实时快讯
          </div>
          <div className="relative flex-1 overflow-hidden">
            <div className="absolute inset-y-0 left-0 w-8 bg-gradient-to-r from-foreground-950 to-transparent z-[1]" />
            <div className="ticker-track items-center gap-10 py-2.5">
              {doubled.map((t, i) => (
                <span key={i} className="flex items-center gap-2 whitespace-nowrap text-xs md:text-sm text-foreground-200">
                  <span
                    className={`inline-flex items-center rounded px-1.5 py-0.5 text-[11px] font-semibold ${
                      t.label === '突发'
                        ? 'bg-primary-500/25 text-primary-200'
                        : t.label === '爆料'
                        ? 'bg-accent-500/25 text-accent-200'
                        : 'bg-secondary-500/30 text-secondary-200'
                    }`}
                  >
                    {t.label}
                  </span>
                  <span className="hover:text-accent-200 cursor-pointer transition">{t.text}</span>
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}